import { isPlatformBrowser } from "@angular/common";
import { Component, EventEmitter, Inject, OnInit, PLATFORM_ID, DOCUMENT } from "@angular/core";
import { GalleryConsignmentProduct } from "src/app/Services/consignment.service";

@Component({
    selector: 'product-share',
    templateUrl: './product-share.component.html',
    inputs: ['isProductShareDailogVisible', 'artistId', 'artworkId', 'linkid', 'galleryId', 'artistName'],
    outputs: ['onCloseDailog'],
    standalone: false
})
export class ProductShareDailogComponent implements OnInit {
    public isProductShareDailogVisible!: boolean;
    public productDetail!: GalleryConsignmentProduct;
    public onCloseDailog = new EventEmitter<boolean>();

    public artistId!: string;
    public galleryId!: string;
    public artworkId!: string;
    public linkid!: string;
    public artistName!: string;

    public selectedProductId!: string | null;
    public shareLink!: string;
    public ProductshareLink!: string;
    public copied: boolean = false;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    public ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const baseUrl = this.document.location.origin;

            // Default to artist profile
            this.shareLink = `${baseUrl}/profile/${this.artistName}`;

            if (this.artistId) {
                this.shareLink = this.linkid
                    ? `${baseUrl}/${this.artistId}/portfolio/${this.linkid}`
                    : `${baseUrl}/${this.artistId}/artworks/${this.artworkId}`;
            }

            if (this.galleryId) {
                this.shareLink = this.linkid
                    ? `${baseUrl}/${this.galleryId}/gallery-shareable-product/${this.linkid}`
                    : `${baseUrl}/${this.artistId}/artworks/${this.artworkId}`;
            }
        }
    }

    public closeDailog() {
        this.isProductShareDailogVisible = false;
        this.onCloseDailog.emit(this.isProductShareDailogVisible);
    }

    public onOpenFacebookUrl() {
        if (isPlatformBrowser(this.platformId)) {
            const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareLink)}`;
            window.open(facebookUrl, '_blank');
        }
    }

    public onOpenWhatsappUrl() {
        if (isPlatformBrowser(this.platformId)) {
            const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(this.shareLink)}`;
            window.open(whatsappUrl, '_blank');
        }
    }

    public onOpenEmailUrl() {
        if (isPlatformBrowser(this.platformId)) {
            const subject = encodeURIComponent("Check out this artwork");
            const body = encodeURIComponent(`Hi,\n\nI wanted to share this artwork with you:\n\n${this.shareLink}\n\nBest regards.`);
            const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=&su=${subject}&body=${body}`;
            window.open(gmailUrl, '_blank');
        }
    }

    public shareOnReddit() {
        if (isPlatformBrowser(this.platformId)) {
            const redditUrl = `https://www.reddit.com/submit?url=${encodeURIComponent(this.shareLink)}`;
            window.open(redditUrl, '_blank');
        }
    }

    public shareOnPinterest() {
        if (isPlatformBrowser(this.platformId)) {
            const pinterestUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(this.shareLink)}`;
            window.open(pinterestUrl, '_blank');
        }
    }

    public copyLink() {
        if (isPlatformBrowser(this.platformId)) {
            const inputElement = document.getElementById('shareLinkInput') as HTMLInputElement;
            inputElement.select();
            document.execCommand('copy');
            this.copied = true;
            setTimeout(() => (this.copied = false), 2000);
        }
    }
}
